import { ViewModel,View, ObservableArray } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { CarBrandManipulationView } from "./carBrandManipulation-view";

export class CarBrandManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'مدیریت برند خودروها ‌';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.carBrands = ObservableArray.create<carBrand>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new CarBrandManipulationView();
    }
    public getTypeId(): string {
        return "VM-B53C941C-78D4-45B1-8ADD-6E482C27D46F"
    }
    public set carBrands(v: ObservableArray<carBrand>) { this._carBrands = v; } public get carBrands(): ObservableArray<carBrand> { return this._carBrands;} private _carBrands: ObservableArray<carBrand>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllCarBrand',{
                FilteringInformation:filteringInformation
            });
            this.carBrands.update(...result.CarBrand.map(q=>{
                let r = new carBrand(this);
                r.id = q.Id;
                r.name = q.Name;
                r.code = q.Code;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    
    async requestCarBrandCreation(){
        let editor = new carBrandEditor(this,new InsertServerUpdater());
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
    async carBrandUpdater(carBrand:carBrand){
        let editor = new carBrandEditor(this,new UpdateServerUpdater());
        carBrand.cloneTo(editor);
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
}

export class carBrand extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:CarBrandManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    
    private _typedParent:CarBrandManipulationViewModel;

    clone(parent:CarBrandManipulationViewModel):carBrand{
        let u = new carBrand(parent);
        this.cloneTo(u);
        return u;
    }

    cloneTo(carBrand:carBrand){
        carBrand.id = this.id;
        carBrand.name = this.name;
        carBrand.code = this.code;
    }

    async edit(){
        this._typedParent.carBrandUpdater(this);
    }    
}

interface IServerUpdater{
    execute(carBrand:carBrand):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'برند خودرو با موفقیت ثبت شد.';
    }
    async execute(carBrand: carBrand): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/CreateCarBrand',{
            Name:carBrand.name,
            Code:carBrand.code
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}
class UpdateServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'برند خودرو با موفقیت به روز رسانی شد.';

    }
    async execute(carBrand: carBrand): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/UpdateCarBrand',{
            Id:carBrand.id,
            Name:carBrand.name,
            Code:carBrand.code
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}

export class carBrandEditor extends carBrand implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:CarBrandManipulationViewModel,serverUpdater:IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
        
    }
    closePopup(resultCode: string = null) {
    }
    
    private _serverUpdater:IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.name)){
            result.push('نام برند خودرو مشخص نشده است.')
        } 
        if(stringIsNullOrEmpty(this.code)){
            result.push('کد برند خودرو مشخص نشده است.')
        }
        return result;
    }

    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت برند خودرو');
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }
}

export class CarBrandSelectorViewModel extends SelectorBaseViewModel<carBrandForSelector>{
    constructor(parentViewModel: ViewModel, checkAccess: boolean = false) {
    
        super(parentViewModel, true);
        this.checkAccess = checkAccess;
        this.refresh();
    }
    
    protected async loadData(): Promise<carBrandForSelector[]> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllCarBrand',{
            CheckAccess: this.checkAccess
        });
        return result.CarBrand.map(q=>{
            let result = new carBrandForSelector(this);
            result.id = q.Id;
            result.title = q.Name;
            return result;
        });
    }

    public set checkAccess(v: boolean) { this._checkAccess = v; } public get checkAccess(): boolean { return this._checkAccess;} private _checkAccess: boolean;
    
}

class carBrandForSelector extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);   
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
}
